import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CsvSvg = function CsvSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#605E5C",
      fillRule: "evenodd",
      d: "M21.78 6.427 17.073 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M17 2.354 21.147 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
      clipRule: "evenodd",
      opacity: 0.64
    }), /*#__PURE__*/_jsx("path", {
      fill: "#33C481",
      fillRule: "evenodd",
      d: "M18 15.515h-.79v-.77h-.02q-.515.89-1.517.89-.713 0-1.14-.387-.43-.387-.43-1.042 0-1.378 1.628-1.609l1.478-.207q0-1.252-1.015-1.252-.89 0-1.609.601v-.809q.217-.164.741-.315a3.4 3.4 0 0 1 .935-.152q1.739 0 1.739 1.845zm-.79-2.495-1.195.169q-.611.087-.857.291-.245.206-.245.662a.74.74 0 0 0 .264.596q.265.223.68.223.587 0 .97-.415.382-.413.383-1.034zM19.232 17 20 14.635h-.767L18.672 17z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#107C41",
      d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F9F7F7",
      d: "m4.76 16 1.924-3.008L4.921 10h1.42l.963 1.912q.132.272.182.406H7.5q.095-.218.199-.422L8.728 10h1.302l-1.81 2.975L10.075 16H8.69l-1.113-2.1a2 2 0 0 1-.132-.28h-.017a1.3 1.3 0 0 1-.128.271L6.154 16H4.759"
    })]
  });
};
export var Csv = function Csv(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: CsvSvg
  }));
};